'use client';

import { useAuth } from '@clerk/nextjs';
import {
  useApiKeysQuery,
  useCreateApiKeyMutation,
  useRevokeApiKeyMutation,
} from '@marine/services/src/rest-api-theboatdb';

/**
 * The key management hooks, gated on this app's Clerk state.
 *
 * This app is now the only place API keys are managed — the dashboard links out
 * to it rather than duplicating the surface. The hooks themselves still live in
 * `@marine/services`, next to the client generated from the API's own schemas,
 * because that is where the query keys, cache invalidation, stale windows and
 * retry policy belong: with the contract, not with one screen.
 *
 * All that is left here is the one thing the package cannot know — whether the
 * user is signed in, which each app asks a different Clerk SDK. Without the
 * gate, a query would fire while signed out, spend a round trip and come back
 * 401; `enabled` is what turns that into "not asked yet".
 */

export const useApiKeys = () => {
  const { isLoaded, isSignedIn } = useAuth();

  return useApiKeysQuery({ enabled: isLoaded && isSignedIn === true });
};

export const useCreateApiKey = useCreateApiKeyMutation;
export const useRevokeApiKey = useRevokeApiKeyMutation;
